import React from 'react';
import "../template-file-css/document-file-template.css";


export const KE_KingdomExpressionsDischarge = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='KE_KingdomExpressionsDischarge' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h4>Kingdom Expressions, LLC.</h4></center></p>

                <p className='w-750'>{`Please complete form in entirety and submit Discharge Form to Kingdom Expressions Behavioral Health Administrative (KE) staff as soon as completed (within 24 hours after KE decision to discharge client). You must confirm the Discharge Date with KE Behavioral Health Administrative staff. ** For example, if this discharge is due to a relocation, death, unplanned, patient directed discharge, etc. Submit this form as soon as you are aware of the fact that the client will no longer receive KE Behavioral Health services.`}
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Clients Name</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Parent/Guardian (if applicable):</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClientsName' name='txtClientsName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtGuardian' name='txtGuardian' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Reason for Discharge:</span>
                    <input type='text' id='txtReasonForDischarge' name='txtReasonForDischarge' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Discharge Date:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Age (At date of discharge):</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Gender:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDischargeDate' name='txtDischargeDate' className='add-only' />
                        </td>
                        <td className='w-250'> <input type='text' id='txtAge' name='txtAge' className='add-only' />
                        </td>
                        <td className='w-250'> <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Address</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtAddress' name='txtAddress' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>City</span> </td>
                        <td className='w-250'> <span className='eleHeader'>State</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Zip Code</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCity' name='txtCity' className='add-only' />
                        </td>
                        <td className='w-250'> <input type='text' id='txtState' name='txtState' className='add-only' />
                        </td>
                        <td className='w-250'> <input type='text' id='txtZipCode' name='txtZipCode' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients Cell:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Home #:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Work #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClientsCell' name='txtClientsCell' className='add-only' />
                        </td>
                        <td className='w-250'> <input type='text' id='txtHome' name='txtHome' className='add-only' />
                        </td>
                        <td className='w-250'> <input type='text' id='txtWork' name='txtWork' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Emergency Contact Name/Relation to client:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Contact:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtEmergencyContactName' name='txtEmergencyContactName' className='add-only' />
                        </td>
                        <td className='w-250'> <input type='text' id='txtContact' name='txtContact' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Dates of Face to Face Contacts, Home Visits, Letters, Telephone Calls, and Community Searches (briefly describe outcomes):</span>
                    <textarea id='txtHomeVisits' name='txtHomeVisits' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Type of Service the client is being discharged from</span>
                    <input type='checkbox' id='cbMhr' name='cbMhr' className='add-only' value='MHR' /> MHR &nbsp;
                    <input type='checkbox' id='cbIop' name='cbIop' className='add-only' value='IOP' /> IOP &nbsp;
                    <input type='checkbox' id='cbCi' name='cbCi' className='add-only' value='CI' /> CI &nbsp;
                    <input type='checkbox' id='cbOp' name='cbOp' className='add-only' value='OP' /> OP &nbsp;
                    <input type='checkbox' id='cbAddiction' name='cbAddiction' className='add-only' value='Addiction L1' /> Addiction L1
                </p>

                <p className='w-750'><span className='eleHeader'>Name and Address of Provider which client is transferring to:</span>
                    <textarea id='txtNameAndAddress' name='txtNameAndAddress' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Name of Institution which client will be residing for long term services (if applicable):</span>
                    <textarea id='txtInstitution' name='txtInstitution' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Clients Diagnosis and List of Psychotropic Meds, Dosage, Frequency and Medical Medications:</span>
                    <textarea id='txtClientsDiagnosis' name='txtClientsDiagnosis' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>Referral Source</b></p>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-300'> <span className='eleHeader'>Contact #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtName' name='txtName' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtContactNumber' name='txtContactNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>PCP Provider Name:</span> </td>
                        <td className='w-300'> <span className='eleHeader'>Doctor and Contact #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtPcpProviderName' name='txtPcpProviderName' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtDoctorNumber' name='txtDoctorNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Primary Discharge DSM V Diagnosis and Level of Need (Locus)</span>
                    <input type='text' id='txtPrimaryDischarge' name='txtPrimaryDischarge' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>Discharge Condition:</span>
                    <input type='radio' id='rbDischargeCondition_Improved' name='rbDischargeCondition' className='add-only' value='Improved' /> Improved &nbsp;
                    <input type='radio' id='rbDischargeCondition_NoChange' name='rbDischargeCondition' className='add-only' value='No Change' /> No Change &nbsp;
                    <input type='radio' id='rbDischargeCondition_Worse' name='rbDischargeCondition' className='add-only' value='Worse' /> Worse &nbsp;
                    <input type='radio' id='rbDischargeCondition_Unknown' name='rbDischargeCondition' className='add-only' value='Unknown' /> Unknown
                </p>

                <p className='w-750'><span className='eleHeader'>Type of Discharge:</span>
                    <input type='radio' id='rbTypeOfDischarge_Planned' name='rbTypeOfDischarge' className='add-only' value='Planned' /> Planned &nbsp;
                    <input type='radio' id='rbTypeOfDischarge_Unplanned' name='rbTypeOfDischarge' className='add-only' value='Unplanned' /> Unplanned
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Discharge Reasons: (check all that apply):</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbstable' name='cbstable' className='add-only' value='stable' /> No further treatment indicated/stable </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDisengage' name='cbDisengage' className='add-only' value='Chose to disengage' /> Chose to disengage
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRefusal' name='cbRefusal' className='add-only' value='Refusal of Services' /> Refusal of Services </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLowerLevel' name='cbLowerLevel' className='add-only' value='Lower level' /> Lower level of care necessary (per clinician)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbClientRequested' name='cbClientRequested' className='add-only' value='Client requested' /> Client requested lower level of care </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbClientRequired' name='cbClientRequired' className='add-only' value='Client required' /> Client required more intensive services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOutpatient' name='cbOutpatient' className='add-only' value='Outpatient' /> Chose other outpatient provider </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEligible' name='cbEligible' className='add-only' value='No longer eligible' /> No longer eligible
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMovedOut' name='cbMovedOut' className='add-only' value='Moved out' /> Moved out of service area </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbUnableToContact' name='cbUnableToContact' className='add-only' value='Unable to contact' /> Unable to contact
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Moved out' /> Other: </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOther' name='txtOther' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Assessment Scale (please select one value for each type of risk):</span>
                    <b>0=</b>none
                    <br />
                    <b>1=</b>mild, ideation only
                    <br />
                    <b>2=</b>moderate, ideation with EITHER plan or history of attempts
                    <br />
                    <b>3=</b>severe, ideation AND plan, with either intent or means
                    <br />
                    <b>na=</b>not assessed
                </p>

                <table className='altRows'>
                    <tr>
                        <td className='w-450'>1. Current Risk to Others Assessment: </td>
                        <td className='w-60'>
                            <input type='radio' id='rbCurrentRisk_0' name='rbCurrentRisk' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbCurrentRisk_1' name='rbCurrentRisk' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbCurrentRisk_2' name='rbCurrentRisk' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbCurrentRisk_3' name='rbCurrentRisk' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbCurrentRisk_na' name='rbCurrentRisk' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>2. Patient's risk to self: </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPatientRisk_0' name='rbPatientRisk' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPatientRisk_1' name='rbPatientRisk' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPatientRisk_2' name='rbPatientRisk' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPatientRisk_3' name='rbPatientRisk' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPatientRisk_na' name='rbPatientRisk' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>3. Current Impairments: </td>
                        <td className='w-60'>
                            <input type='radio' id='rbImpairments_0' name='rbImpairments' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbImpairments_1' name='rbImpairments' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbImpairments_2' name='rbImpairments' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbImpairments_3' name='rbImpairments' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbImpairments_na' name='rbImpairments' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>4. Mood Disturbance (Depression or Mania) </td>
                        <td className='w-60'>
                            <input type='radio' id='rbMoodDisturbance_0' name='rbMoodDisturbance' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbMoodDisturbance_1' name='rbMoodDisturbance' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbMoodDisturbance_2' name='rbMoodDisturbance' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbMoodDisturbance_3' name='rbMoodDisturbance' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbMoodDisturbance_na' name='rbMoodDisturbance' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>5. Anxiety </td>
                        <td className='w-60'>
                            <input type='radio' id='rbAnxiety_0' name='rbAnxiety' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbAnxiety_1' name='rbAnxiety' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbAnxiety_2' name='rbAnxiety' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbAnxiety_3' name='rbAnxiety' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbAnxiety_na' name='rbAnxiety' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>6. Psychosis/Hallucinations/Delusions </td>
                        <td className='w-60'>
                            <input type='radio' id='rbHallucinations_0' name='rbHallucinations' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbHallucinations_1' name='rbHallucinations' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbHallucinations_2' name='rbHallucinations' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbHallucinations_3' name='rbHallucinations' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbHallucinations_na' name='rbHallucinations' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>7. Thinking/Cognition/Memory/Concentration Problems </td>
                        <td className='w-60'>
                            <input type='radio' id='rbCognition_0' name='rbCognition' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbCognition_1' name='rbCognition' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbCognition_2' name='rbCognition' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbCognition_3' name='rbCognition' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbCognition_na' name='rbCognition' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>8. Impulsive/Reckless/Aggressive Behavior </td>
                        <td className='w-60'>
                            <input type='radio' id='rbImpulsive_0' name='rbImpulsive' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbImpulsive_1' name='rbImpulsive' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbImpulsive_2' name='rbImpulsive' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbImpulsive_3' name='rbImpulsive' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbImpulsive_na' name='rbImpulsive' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>9. Activities of Daily Living Problems </td>
                        <td className='w-60'>
                            <input type='radio' id='rbActivities_0' name='rbActivities' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbActivities_1' name='rbActivities' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbActivities_2' name='rbActivities' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbActivities_3' name='rbActivities' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbActivities_na' name='rbActivities' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>10. Weight Change Associated with a Behavioral Diagnosis </td>
                        <td className='w-60'>
                            <input type='radio' id='rbWeightChange_0' name='rbWeightChange' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbWeightChange_1' name='rbWeightChange' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbWeightChange_2' name='rbWeightChange' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbWeightChange_3' name='rbWeightChange' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbWeightChange_na' name='rbWeightChange' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>11. Medical/Physical Condition </td>
                        <td className='w-60'>
                            <input type='radio' id='rbMedical_0' name='rbMedical' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbMedical_1' name='rbMedical' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbMedical_2' name='rbMedical' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbMedical_3' name='rbMedical' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbMedical_na' name='rbMedical' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>12. Substance Abuse/Dependence </td>
                        <td className='w-60'>
                            <input type='radio' id='rbDependence_0' name='rbDependence' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbDependence_1' name='rbDependence' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbDependence_2' name='rbDependence' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbDependence_3' name='rbDependence' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbDependence_na' name='rbDependence' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>13. Job/School Performance Problems </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPerformance_0' name='rbPerformance' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPerformance_1' name='rbPerformance' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPerformance_2' name='rbPerformance' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPerformance_3' name='rbPerformance' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbPerformance_na' name='rbPerformance' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>14. Social/Relationship/Marital/Family Problems </td>
                        <td className='w-60'>
                            <input type='radio' id='rbRelationship_0' name='rbRelationship' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbRelationship_1' name='rbRelationship' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbRelationship_2' name='rbRelationship' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbRelationship_3' name='rbRelationship' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbRelationship_na' name='rbRelationship' className='add-only' value='na' /> na
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>15. Legal Problems </td>
                        <td className='w-60'>
                            <input type='radio' id='rbLegalProblems_0' name='rbLegalProblems' className='add-only' value='0' /> 0 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbLegalProblems_1' name='rbLegalProblems' className='add-only' value='1' /> 1 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbLegalProblems_2' name='rbLegalProblems' className='add-only' value='2' /> 2 </td>
                        <td className='w-60'>
                            <input type='radio' id='rbLegalProblems_3' name='rbLegalProblems' className='add-only' value='3' /> 3
                        </td>
                        <td className='w-60'>
                            <input type='radio' id='rbLegalProblems_na' name='rbLegalProblems' className='add-only' value='na' /> na
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Recommendation(s) for Future Treatment/Follow-up:</span>
                    <input type='text' id='txtRecommendation' name='txtRecommendation' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> {`Clients Signature (if available/if applicable)`} </td>
                        <td className='small w-250'> {`(Parent/Guardian Signature (if available/if applicable)`} </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Kingdom Expressions Staff Signature: </td>
                        <td className='w-375'>LMHP Signature: </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Clinical Director Signature:</td>
                    </tr>
                </table>



            </div>
        </form>
    )
}